import request from '@/utils/httpRequest'

// 首页-企业信息-证书
export function ApiWebCertificate () {
  return request({
    url: request.adornUrl('/web/office/company/honor/certificate'),
    method: 'get',
    params: request.adornParams()
  })
}

// 关于集百优
export function ApiWebAbout () {
  return request({
    url: request.adornUrl('/web/office/company/index'),
    method: 'post',
    data: request.adornData()
  })
}

// 关于集百优-荣誉分页
export function ApiWebAboutHonor (params) {
  return request({
    url: request.adornUrl('/web/office/company/honor/table'),
    method: 'post',
    data: request.adornData(params)
  })
}

// 关于集百优-合作伙伴
export function ApiWebAboutPartner () {
  return request({
    url: request.adornUrl('/web/office/company/partner/table'),
    method: 'post',
    data: request.adornData()
  })
}

// 关于我们顶部背景图
export function ApiWebBackdropImg () {
  return request({
    url: request.adornUrl('/web/office/company/backdrop/img'),
    method: 'get',
    params: request.adornParams()
  })
}

// 页脚-合作伙伴
export function ApiWebFooterPartner () {
  return request({
    url: request.adornUrl('/web/company/partner'),
    method: 'get',
    params: request.adornParams()
  })
}

// 页脚-公司信息、联系我们-公司信息
export function ApiWebCompanyInfo () {
  return request({
    url: request.adornUrl('/web/company/info'),
    method: 'get',
    params: request.adornParams()
  })
}



// WEBPACK FOOTER //
// ./src/api/company.js